import { render, staticRenderFns } from "./EntryOrders.vue?vue&type=template&id=0515f72b&"
import script from "./EntryOrders.vue?vue&type=script&lang=js&"
export * from "./EntryOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports